import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "submit"]
  
  connect() {
  }
  
  initialize() {
    this.timeout = null
    this.debounceMs = 300
  }
  
  filter(event) {
    event.preventDefault()
    
    if (event.target && event.target.name === 'search') {
      const searchValue = event.target.value.trim()
      
      if (searchValue.length > 0 && searchValue.length < 3) {
        return
      }
    }
    
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.formTarget.requestSubmit()
    }, this.debounceMs)
  }

  clearSearch(event) {
    event.preventDefault()
    const searchInput = this.formTarget.querySelector('input[name="search"]')
    if (searchInput) {
      searchInput.value = ''
      clearTimeout(this.timeout)
      this.formTarget.requestSubmit()
    }
  }
  
  removeCategory(event) {
    event.preventDefault()
    const category = event.currentTarget.dataset.category
    const checkboxes = this.formTarget.querySelectorAll('input[name="categories[]"]')
    
    checkboxes.forEach(checkbox => {
      if (checkbox.value === category) {
        checkbox.checked = false
      }
    })
    
    this.filter()
  }
  
  clearPriceRange(event) {
    event.preventDefault()
    const radioButtons = this.formTarget.querySelectorAll('input[name="price_range"]')
    radioButtons.forEach(radio => {
      if (radio.value === '') {
        radio.checked = true
      } else {
        radio.checked = false
      }
    })
    
    this.filter()
  }
  
  clearCity(event) {
    event.preventDefault()
    const city = event.currentTarget.dataset.city
    const citySelects = this.formTarget.querySelectorAll('select[name="city[]"] option')
    
    citySelects.forEach(option => {
      if (option.value === city) {
        option.selected = false
      }
    })
    
    const multiselectController = this.application.getControllerForElementAndIdentifier(
      this.formTarget.querySelector('[data-controller*="multiselect"]'), 
      'multiselect'
    )
    if (multiselectController && multiselectController.update) {
      multiselectController.update()
    }
    
    this.filter()
  }

  removeLocation(event) {
    event.preventDefault()
    const location = event.currentTarget.dataset.location
    
    const locationSearchController = this.application.getControllerForElementAndIdentifier(
      this.formTarget.querySelector('[data-controller*="location-search"]'), 
      'location-search'
    )
    
    if (locationSearchController) {
      if (locationSearchController.selections && locationSearchController.selections.has(location)) {
        locationSearchController.selections.delete(location)
        locationSearchController.updateSelectedDisplay()
        locationSearchController.updateHiddenInputs()
      }
    }
    
    this.filter()
  }
}
